// Functions for Airtable Object representations
import * as locCon from "../LocalConstants"
import * as libCon from '../community-hats-js-library/Constants';
import { notification } from "antd";

export const getNewStatus = (currentStatus) => {

    let newStatus = null
    // Gets the new State
    switch (currentStatus) {
        case locCon.ATO_EMPTY:
        case locCon.ATO_ONLY_LOCAL:
            newStatus = locCon.ATO_ONLY_LOCAL
            break;

        case locCon.ATO_UP_TO_DATE:
        case locCon.ATO_NEEDS_SYNCH:
            newStatus = locCon.ATO_NEEDS_SYNCH
            break
        default:
            newStatus = currentStatus;
            break
    }

    return newStatus
}





export const copyToClipboard = async (text, message) => {
    await navigator.clipboard.writeText(`${text}`);
    showNotification(message)
};

export const getClipboardValue = async () => {
    const value = await navigator.clipboard.readText();
    return value
};

export const showNotification = (message) => {
    notification.open({
        message: message,
        showProgress: true,
        pauseOnHover: true,
        placement: "top",
        duration: 6,
        style: {
            background: "var(--background-color-1-transparent)"
        }
    })

}

export const showError = (message) => {
    notification.open({
        message: message,
        showProgress: true,
        pauseOnHover: true,
        placement: "top",
        style: {
            background: "var(--primary-color-2-transparent)"
        }
    })


}

export const buildImageUrl = (imagePath) => {
    return "/img/" + imagePath
}


// Pure link/locale helpers. These take no credentials and make no network call,
// so they stay in the client instead of going to the server.

export const buildAirtableFormLink = (baseLink, parameters = {}, hidden_params = []) => {
    // If no parameters, just return the base link
    if (Object.keys(parameters).length === 0) return baseLink;

    // Start query string
    let query = '';

    // Add prefill parameters
    for (const [key, value] of Object.entries(parameters)) {
        const encodedKey = encodeURIComponent(`prefill_${key}`);
        const encodedValue = encodeURIComponent(value);
        query += `${encodedKey}=${encodedValue}&`;
    }

    // Add hidden parameters
    for (const field of hidden_params) {
        const encodedHideKey = encodeURIComponent(`hide_${field}`);
        query += `${encodedHideKey}=true&`;
    }

    // Remove trailing "&" and build final URL
    query = query.slice(0, -1);

    return `${baseLink}?${query}`;
}

export const getActionItemColumnsByLocale = (locale) => {
    switch (locale) {
        case libCon.EN:
            return [libCon.ATF_DESCRIPTION, libCon.ATF_ACTION];
        case libCon.GU:
            return [libCon.ATF_DESCRIPTION_GU, libCon.ATF_ACTION_GU];
        case libCon.HI:
            return [libCon.ATF_DESCRIPTION_HI, libCon.ATF_ACTION_HI];
        case libCon.ES:
            return [libCon.ATF_DESCRIPTION_ES, libCon.ATF_ACTION_ES];
        default:
            return [libCon.ATF_DESCRIPTION, libCon.ATF_ACTION];
    }
}